import { cssTheme } from '@uds/theme-utils';
import { css } from 'linaria';

export const classNames = {
  container: css`
    margin-bottom: calc(${cssTheme.gu1} * -1);

    ${cssTheme.breakpoints.sm} {
      margin-bottom: calc(${cssTheme.gu2} * -1);
    }
  `,
};
